// extracted by mini-css-extract-plugin
export default {"title":"n_-z","warning":"o_-z","sizeOptionsLegendText":"p_-z"};